


















































import { Component, Vue } from "vue-property-decorator";
@Component
export default class Records extends Vue {
  // export default {
  public data() {
    return {
      total: 0,
      tableData: [],
      loading: false,
      dateRange: "",
      parmas: {
        search: "",
        page_size: 10,
        page: 1,
        begin_at: "",
        end_at: "",
        activity_instance_id: this.$router.currentRoute.params.id,
      },
    };
  }

  public async created() {
    this.queryList();
  }

  public queryListName() {
    this.$data.parmas.page = 1;
    this.queryList();
  }
  /**
   * 列表查询
   */
  public async queryList() {
    const { parmas } = this.$data;
    this.$data.loading = true;
    try {
      const dataList = await this.$store.dispatch("getRecordTableList", parmas);
      this.$data.tableData = dataList.list;
      this.$data.total = dataList.total;
      this.$data.loading = false;
    } catch (error) {
      this.$data.loading = false;
      (this as any).$message.error(error.msg || error.message || error);
    }
  }

  /**
   * 单页面显示条数切换
   */
  public onPageSizeChange(e: any) {
    this.$data.parmas.page_size = e;
    this.queryList();
  }

  /**
   * 切换当前页
   */
  public onChange(e: any) {
    this.$data.parmas.page = e;
    this.queryList();
  }

  public onDateChange(value: any) {
    if (value) {
      this.$data.parmas.begin_at = value[0];
      this.$data.parmas.end_at = value[1];
    } else {
      this.$data.parmas.begin_at = undefined;
      this.$data.parmas.end_at = undefined;
    }
  }
}
